import { createAction } from 'redux-actions';
import api from '@/utils/apiClient';

export const setUserFetching = createAction('SET_USER_FETCHING');
export const setUserError = createAction('SET_USER_ERROR');
export const setAssignUserList = createAction('SET_ASSIGN_USER_LIST');
export const setUserFilters = createAction('SET_USER_LIST_FILTER');
export const setUserState = createAction('SET_USER_STATE');

export const getCPUsersList = (filter) => async (dispatch, getState) => {
  const isFromLP = getState().assignPage.isFromLearningPath;
  const isFromTP = getState().assignPage.isFromTrainingProvider;
  const defaultError = `Error occurred getting ${
    filter.assigned ? 'Assigned' : 'Assign'
  } user list`;
  dispatch(setUserFetching());
  try {
    const { data, isSuccess } = await api.cpUser.getUserListByOrgId(filter);
    if (isSuccess) dispatch(setAssignUserList({ ...data, isFromLP, isFromTP }));
    else throw new Error(data?.messages?.[0] ?? defaultError);
  } catch (error) {
    dispatch(setUserError(error.message));
    console.error(defaultError, error.message);
  }
};
